import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import RootRedirect from "@/pages/RootRedirect";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import SysAdmin from "@/pages/SysAdmin";
import Team from "@/pages/Team";
import FAQBuilder from "@/pages/FAQBuilder";
import PixelBuilder from "@/pages/PSPixelBuilder";
import PSPixelBulk from "@/pages/PSPixelBulk";
import GAPixelBuilder from "@/pages/GAPixelBuilder";
import RichTextBuilder from "@/pages/RichTextBuilder";
import GalleryBuilder from "@/pages/GalleryBuilder";
import EditComponent from "@/pages/EditComponent";
import PixelAnalytics from "@/pages/PixelAnalytics";
import Success from "@/pages/Success";
import EmbedFAQ from "@/pages/EmbedFAQ";
import EmbedPixelInfo from "@/pages/EmbedPixelInfo";
import EmbedRichText from "@/pages/EmbedRichText";
import EmbedGallery from "@/pages/EmbedGallery";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />

            {/* public */}
            <Route path="/login" element={<Login />} />
            <Route path="/embed/faq/:id" element={<EmbedFAQ />} />
            <Route path="/embed/pixel/:id" element={<EmbedPixelInfo />} />
            <Route path="/embed/richtext/:id" element={<EmbedRichText />} />
            <Route path="/embed/gallery/:id" element={<EmbedGallery />} />

            {/* authenticated */}
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

            <Route path="/create/faq" element={<ProtectedRoute><FAQBuilder /></ProtectedRoute>} />
            <Route path="/create/pixel" element={<Navigate to="/create/ps_pixel" replace />} />
            <Route path="/create/ps_pixel" element={<ProtectedRoute><PixelBuilder /></ProtectedRoute>} />
            <Route path="/create/ps_pixel/bulk" element={<ProtectedRoute><PSPixelBulk /></ProtectedRoute>} />
            <Route path="/create/ga_pixel" element={<ProtectedRoute><GAPixelBuilder /></ProtectedRoute>} />
            <Route path="/create/richtext" element={<ProtectedRoute><RichTextBuilder /></ProtectedRoute>} />
            <Route path="/create/gallery" element={<ProtectedRoute><GalleryBuilder /></ProtectedRoute>} />

            <Route path="/edit/:type/:id" element={<ProtectedRoute><EditComponent /></ProtectedRoute>} />
            <Route path="/pixel/:id/analytics" element={<ProtectedRoute><PixelAnalytics /></ProtectedRoute>} />

            <Route path="/success/:type/:id" element={<ProtectedRoute><Success /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute roles={["tenant_admin", "sysadmin"]}><Team /></ProtectedRoute>} />
            <Route path="/sysadmin" element={<ProtectedRoute roles={["sysadmin"]}><SysAdmin /></ProtectedRoute>} />

            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
